<template>
    <component :style="cssProps" :is="layout">
      <router-view />
    </component>
</template>
<script>

const default_layout = "basic"
  export default {
    computed: {
      layout(){
        return (this.$route.meta.layout || default_layout) + '-layout'
      },
      cssProps () {
          var themeColors = {}
          Object.keys(this.$vuetify.theme.themes.light).forEach((color) => {
            themeColors[`--v-${color}`] = this.$vuetify.theme.themes.light[color]
          })
          return themeColors
      }
    }
  }
  </script>
  <style lang="scss">
    .v-chip.primary.v-chip--outlined{
      color: var(--v-primary) !important;
    }
    .v-chip.grey.v-chip--outlined{
      color: var(--v-grey) !important;
    }
    .v-chip.success.v-chip--outlined{
        color: var(--v-success) !important;
    }
    .v-chip.error.v-chip--outlined{
        color: var(--v-error) !important;
    }


    .theme--light.v-chip.primary{
      color: var(--v-primary) !important;
      background-color:var(--v-primaryFade) !important;
    }
    .theme--light.v-chip.grey{
      color:var(--v-grey) !important;
      background-color:var(--v-greyFade) !important;
    }
    .theme--light.v-chip.success{
      color: var(--v-success) !important;
      background-color:var(--v-successFade) !important;
    }
    .theme--light.v-chip.error{
        color: var(--v-error) !important;
        background-color:var(--v-errorFade) !important;
    }
   
    .theme--light.v-chip.accent{
      color:var(--v-accent) !important;
      background-color:var(--v-accentFade) !important;
    }
  </style>